import React from 'react';
interface SectionProps {
  id?: string;
  eyebrow?: string;
  title?: React.ReactNode;
  intro?: React.ReactNode;
  tone?: 'white' | 'tint' | 'amber' | 'deep';
  width?: 'content' | 'narrow';
  children: React.ReactNode;
}
const toneClasses: Record<NonNullable<SectionProps['tone']>, string> = {
  white: 'bg-white text-ink',
  tint: 'bg-canvas text-ink',
  amber: 'bg-amber-100 text-ink',
  deep: 'bg-night text-white'
};
export function Section({
  id,
  eyebrow,
  title,
  intro,
  tone = 'white',
  width = 'content',
  children
}: SectionProps) {
  const hasHeader = Boolean(eyebrow || title || intro);
  const isDeep = tone === 'deep';
  return <section id={id} className={`w-full py-16 md:py-24 ${toneClasses[tone]}`} data-id="element-139" data-mp="2nr7wcu5pyg4">
      <div className={`mx-auto w-full px-5 md:px-8 ${width === 'narrow' ? 'max-w-narrow' : 'max-w-content'}`} data-id="element-140" data-mp="7ndkql62pcoe">
        {hasHeader && <header className="mx-auto max-w-narrow text-center" data-id="element-141" data-mp="105iv5yxnuay1">
            {eyebrow && <p className={`mb-4 font-display text-xs font-extrabold uppercase tracking-[0.18em] ${isDeep ? 'text-amber-400' : 'text-amber-700'}`} data-id="element-142" data-mp="2zk24hnwun4ee">
                {eyebrow}
              </p>}
            {title && <h2 className={`font-display text-[2rem] font-extrabold leading-[1.1] tracking-tight md:text-5xl ${isDeep ? 'text-white' : 'text-night'}`} data-id="element-143" data-mp="33lnjpfwuvurr">
                {title}
              </h2>}
            {intro && <p className={`mx-auto mt-5 max-w-2xl text-lg md:text-xl ${isDeep ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-144" data-mp="3rc1al33pfnkr">
                {intro}
              </p>}
          </header>}
        <div className={hasHeader ? 'mt-12 md:mt-16' : ''} data-id="element-145" data-mp="1sw528qg2lgvt">{children}</div>
      </div>
    </section>;
}